import React, { useState } from 'react'
import {FaBars,FaTimes} from "react-icons/fa"
import {Link} from "react-scroll"

import {MdKeyboardArrowRight} from "react-icons/md"
const Navbar = () => {
    const [nav,setNav]=useState();
    const [back,setBack] = useState(false)
    const links = [
        {
          id: 1,
          link: "Home",
        },
        {
          id: 2,
          link: "About",
        },
        {
          id: 3,
          link: "Statistics",
        },
        {
          id: 4,
          link: "Skills",
        },
        {
          id: 5,
          link: "Projects",
        },
       
        {
          id: 6,
          link: "Contact",
        },
        
      ];
      const changeBackground=()=>{
        if(window.scrollY>=80)
        {
          setBack(true);
        }
        else{
          setBack(false)  
        }
      }
      window.addEventListener("scroll", changeBackground)
      const handleClick=() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      };
  return (
    <div className={back?'flex justify-between items-center w-full h-20 px-4 text-white fixed z-10 backdrop-blur-xl':'flex justify-between items-center w-full h-20 px-4 text-white fixed z-10 bg-transparent'}>
       <div >
        <h1 className='text-3xl ml-5 font-signature cursor-pointer' onClick={handleClick}>Supriyo</h1>
       </div>
       <ul className='hidden md:flex md:justify-evenly md:items-center'>
       
           {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-3 text-xl cursor-pointer
               text-slate-200 hover:scale-110 hover:text-amber-500 duration-300"
            >
              <Link to={link} smooth duration={500}>
                {link}
              </Link>
              {/* {link} */}
            </li>
          ))}
          <button className=' group text-slate-200 text-xl w-fit
                flex items-center rounded-md cursor-pointer bg-transparent hover:text-amber-500'>
                <a href='https://drive.google.com/file/d/1eRwXczL8jZx5wLPnkHcaS3rr8x5Jczlq/view?usp=sharing' target="_blank" rel="noreferrer" >Resume</a>
            </button>
       </ul>
       <div onClick={()=>setNav(!nav)} className='cursor-pointer z-10 pr-4 text-amber-500 md:hidden'>
        {nav ? <FaTimes size={30}/>:
        <FaBars size={30}/>}
       </div>
       {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 right-0 w-full 
        h-screen bg-gradient-to-b from-slate-800 to-fuchsia-800 text-amber-500">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              {/* <Link
                onClick={() => setNav(!nav)}
                to={link}
                smooth
                duration={500}
              > */}
                {/* {link} */}
              {/* </Link> */}
              <Link to={link} smooth duration={500} onClick={() => setNav(!nav)}>
                {link}
              </Link>
            </li>
          ))}
          <button className=' group text-amber-500 w-fit text-3xl py-6 px-4
                flex items-center cursor-pointer bg-transparent'>
                <a href='https://drive.google.com/file/d/1eRwXczL8jZx5wLPnkHcaS3rr8x5Jczlq/view?usp=sharing' target="_blank" rel="noreferrer" >Resume</a>
              <span className="group-hover:rotate-90 duration-300">
                <MdKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </button>
        </ul>
      )}
    </div>
  )
}

export default Navbar